import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme) => ({
  fieldGroup: {
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
    },
  },
  radioGroup: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  field: {
    marginTop: theme.spacing(2),
    paddingLeft: '10px',
    paddingRight: '10px',
  },
  item: {
    marginBottom: theme.spacing(2),
  },
  divider: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  corpoFormulario: {
    margin: theme.spacing(2),
    paddingLeft: '10px',
    paddingRight: '10px',
  },
  dados: {
    padding: theme.spacing(1),
  },
  titleCampo: {
    fontSize: '15px',
    marginTop: theme.spacing(2),
  },
  cabecalhoBotao: {
    paddingRight: theme.spacing(1),
  },
}))
